import { render } from "./AddImageModal.vue?vue&type=template&id=ddee66ee&scoped=true"
import script from "./AddImageModal.vue?vue&type=script&lang=js"
export * from "./AddImageModal.vue?vue&type=script&lang=js"

import "./AddImageModal.vue?vue&type=style&index=0&id=ddee66ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddee66ee"]])

export default __exports__